module.exports = __webpack_public_path__ + "static/media/Next_Generation_Portal.354549f3.jpg";